import React from "react";
import "./EngagedSection.scss";
import imageAbiturient from "./images/lubo-abiturient.webp";

export default function RingsSection() {
  return (
    <div className="relative overflow-hidden">
      <div className="container">
        <div className="abiturient-image">
          <img src={imageAbiturient} alt="Abiturient" width="100%" height="auto" />
        </div>
        <div className="flex flex-align-center flex-justify-end-md flex-justify-center flex-justify-start-lg m-top-4 m-bottom-4 relative text-justify">
          <div className="col-12-xs col-12-sm col-12-md col-7-lg col-5">
            <div className="text-lg text-md-xs m-top-4 font-weight-700">Най-накрая оцелях!</div>
            <div className="text-lg text-md-xs m-top-2">
              След 12 години учене, без да ме изгонят (е, явно имат търпение, шапки долу!), дойде време да празнуваме! Очакват ви хапване, пийване, танци и смях, а аз ще се опитам да изглеждам толкова сериозен, че за момент дори да си помислите, че съм възрастен… но не се подвеждайте!
              <br />
              <br />
              <b>Важни уточнения:</b>
              <br />
              <br />
              <div className="flex flex-align-center flex-nowrap m-bottom-1">
                <div className="flex flex-align-center flex-justify-center icon-circle"><i className="fa-solid fa-utensils"></i></div>
                <div className="text-md">Хапване (обещавам, че няма да съм аз готвил)</div>
              </div>
              <div className="flex flex-align-center flex-nowrap m-bottom-1">
                <div className="flex flex-align-center flex-justify-center icon-circle"><i className="fa-solid fa-martini-glass-citrus"></i></div>
                <div className="text-md">Пийване (с мярка... или поне докато не ни спрат тока)</div>
              </div>
              <div className="flex flex-align-center flex-nowrap m-bottom-1">
                <div className="flex flex-align-center flex-justify-center icon-circle"><i className="fa-solid fa-music"></i></div>
                <div className="text-md">Танци (ако видите странни танци – не, не е бъг, просто доброто настроение взема превес!)</div>
              </div>
              <div className="flex flex-align-center flex-nowrap m-bottom-1">
                <div className="flex flex-align-center flex-justify-center icon-circle"><i className="fa-solid fa-file-circle-check"></i></div>
                <div className="text-md">Дипломата е истинска, въпреки че понякога учителите може би са имали съмнения.</div>
              </div>
              <div className="flex flex-align-top flex-nowrap m-bottom-1">
                <div className="m-top-0 flex flex-align-center flex-justify-center icon-circle bg-warning"><i className="fa-solid fa-person-falling-burst"></i></div>
                <div className="text-md">Попълването на формуляра в края на страницата е задължително и поверено на строгия контролен орган – мама. Всички неподадени форми ще бъдат обработени лично от нея, така че внимавайте!</div>
              </div>
              <br />
              За мен (и за цялата ми горда фамилия) ще бъде чест да сте част от този паметен ден!
              <br />
              <br />
              Молим да потвърдите вашето присъствие до{" "}
              <span className="text-primary text-bold">
                <br className="hidden-xs hidden-sm" />
                01 Май, 2025г.
              </span>
              , като попълните формуляра в края на тази страница.
            </div>
            <div className="m-top-4 m-bottom-4">
              <a href="#confirm" className="confirm-btn confirm-btn-secondary full-width-xs full-width-sm full-width-md ">
                <i className="fa-solid fa-calendar-check m-right-1"></i>ПОТВЪРДИ{" "}
                <span className="hidden-xs">ПРИСЪСТВИЕ</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
